<script>
import AdminLayout from '@layouts/admin-main'
import AccountList from '@components/admin/account-list'
import MemberNav from '@components/admin/member-nav'

export default {
  page: {
    title: 'Admin::MemberAccountList',
    meta: [{ name: 'description', content: 'Admin::MemberAccountList' }],
  },
  components: { AdminLayout, AccountList, MemberNav },
}
</script>

<template>
  <AdminLayout>
    <MemberNav></MemberNav>
    <AccountList></AccountList>
  </AdminLayout>
</template>
